import PropTypes from 'prop-types';
import React from 'react';
import ConfirmModal from '@mulesoft/exchange-ui-components/lib/components/ConfirmModal';

const DeleteConfirmModal = ({ onCancel, onConfirm }) => {
  const handleCancel = React.useCallback(() => {
    onCancel();
  }, [onCancel]);

  const handleConfirm = React.useCallback(() => {
    onConfirm();
  }, [onConfirm]);

  return (
    <ConfirmModal
      title="Delete scanner"
      confirmButtonText="Delete"
      cancelButtonText="Go back"
      body={
        <div>
          <p>Are you sure you want to delete this scanner?</p>
          <p>
            Your imported agents will remain in Exchange, but they will remain
            at this existing version. Any new agents added or existing agents
            updated in your target system will not be updated here unless you
            add this scanner again.
          </p>
        </div>
      }
      isDanger
      onCancel={handleCancel}
      onConfirm={handleConfirm}
    />
  );
};

DeleteConfirmModal.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired
};

export default DeleteConfirmModal;
